import React from 'react';

import { Alert, Grid } from '@mui/material';

import { PopulationRegister } from '../../../../utilities/schemas/populationRegister';

const WITHHELD_DATA = 'The provider withholds some or all of their data, so parts of this report may be empty.';

const PopulationRegisterSecrecyAlerts = ({
  record,
}: {
  record?: PopulationRegister['record'];
}) => {
  const hasSecrecy = !!record?.secrecy?.secrecy;
  const hasProtectedRegistration = !!record?.protectedRegistration
    || !!record?.secrecy?.secrecySetBySpar;

  if (!hasSecrecy && !hasProtectedRegistration) return null;

  return (
    <>
      {hasSecrecy && (
        <Grid container justifyContent="center">
          <Alert severity="warning">
            {`This individual has a secrecy marker. ${WITHHELD_DATA}`}
          </Alert>
        </Grid>
      )}
      {hasProtectedRegistration && (
        <Grid container justifyContent="center">
          <Alert severity="warning">
            {`This individual has a protected population registration. ${WITHHELD_DATA}`}
          </Alert>
        </Grid>
      )}
    </>
  );
};

export default PopulationRegisterSecrecyAlerts;
